import { Button } from '@vkontakte/vkui';
import React from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getVigboUrl } from 'reactApp/modules/vigbo/vigbo.helpers';
import { VigboLicenceNote } from 'reactApp/ui/VigboLicenceNote/VigboLicenceNote';
import opener from 'reactApp/utils/opener';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './UnlinkedBottomContent.css';

export function UnlinkedBottomContent() {
    const email = useSelector(UserSelectors.getEmail);

    const handleLinkAccounts = () => {
        const linkAccounts = getVigboUrl('linkAccounts', { email });
        if (linkAccounts) {
            opener(linkAccounts);
        }

        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'button-connection-click',
        });
    };

    return (
        <>
            <Button onClick={handleLinkAccounts} size="l">
                Связать аккаунты
            </Button>
            <VigboLicenceNote className={styles.licence} />
        </>
    );
}
